import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';

const result: PartialRecursive<IBucket['settings']> = {
  searchFilters: {
    venue: {
      venueType: [
        'countryHouseManorHouse',
        'barn',
        'gardenOutdoor',
        'castle',
        'hotel',
        'uniqueVenueType',
        'pubRestaurant',
        'golfCourse',
        'cruiseBoatYacht',
        'conferenceCentre',
        'placeOfWorship',
        'winery',
      ],
    },
  },
};

export default result;
